import { render, staticRenderFns } from "./DeviceDashboard.vue?vue&type=template&id=c365b818&scoped=true&"
import script from "./DeviceDashboard.vue?vue&type=script&lang=ts&"
export * from "./DeviceDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./DeviceDashboard.vue?vue&type=style&index=0&id=c365b818&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c365b818",
  null
  
)

export default component.exports